class HoursOfServiceCollection extends App.Collections.BaseCollection {
    url = 'HOS';
    model = App.Models.HoursOfService;
}

App.Collections.HoursOfService = HoursOfServiceCollection;
